import React, { Component } from 'react';
import { supabase } from '../../lib/supabase';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import { Link } from "react-router-dom";
import SlickCarousel from '../Galery/Carousel/SlickCarousel/SlickCarousel';
import RecipesListingPage from '../../components/RecipesPages/RecipesListingPage/RecipesListingPage';
import classes from './LandingPage.module.css';

class LandingPage extends Component {
	state = {
		latestRecipes: [],
		childrenRecipes: [],
		carouselImages: [],
		loading: true
	};

	async componentDidMount() {
		const { data, error } = await supabase
			.from('recipes')
			.select('*')
			.order('id', { ascending: false });

		if (error) {
			console.error(error);
			this.setState({ loading: false });
			return;
		}

		const nonChildren = data.filter(r => r.type !== 'children');
		const children = data.filter(r => r.type === 'children');

		this.setState({
			latestRecipes: {
				sweet: nonChildren.filter(r => r.type === 'sweet').slice(0, 3),
				salted: nonChildren.filter(r => r.type === 'salted').slice(0, 3),
			},
			childrenRecipes: children,
			carouselImages: nonChildren
				.flatMap(r => r.images || [])
				.slice(0, 3),
			loading: false
		});
	}

	render() {
		const { latestRecipes, childrenRecipes, carouselImages, loading } = this.state;

		if (loading) {
			return <div className={classes.MainSection}></div>; //Loading...
		}

		return (
			<Aux>
				{/* HERO / MAIN RECIPES */}
				<section className={`${classes.MainSection} ${classes.CarouselWrapper}`}>
					<SlickCarousel images={carouselImages} variant="landing" isLandingPage/>
				</section>

				<h2 className={classes.SectionMainTitle}>Най-нови сладки и солени рецепти</h2>

				{/* SWEET */}
				<section className={`${classes.TypeSection} ${classes.SweetSection}`}>
					<p>
						Не можете да решите дали Ви се хапва сладко или солено?
						Разгледайте нашата специална страница{' '}
							<Link to="/sladko-ili-soleno" className={classes.SeoLink}>Сладко или Солено</Link>
						{' '}с подбрани рецепти за всяко настроение.
					</p>
				</section>

				{/* SWEET */}
				<section className={`${classes.TypeSection} ${classes.SweetSection}`}>
					<div className={classes.SectionHeader}>
						<div>
							<h3>🍰 Домашни десерти, сладкиши и изкушения</h3>
						</div>
						<a href="/recipes/sweet" className={classes.MoreLink}>
							Виж всички →
						</a>
					</div>

					<div className={classes.LatestRecipes}>
						<RecipesListingPage
							dataRecipes={latestRecipes.sweet}
							isLandingPage
						/>
					</div>
				</section>

				{/* SALTED */}
				<section className={`${classes.TypeSection} ${classes.SaltedSection}`}>
					<div className={classes.SectionHeader}>
						<div>
							<h3>🧂 Основни ястия, тестени и солени предложения</h3>
						</div>
						<a href="/recipes/salted" className={classes.MoreLink}>
						Виж всички →
						</a>
					</div>

					<div className={classes.LatestRecipes}>
						<RecipesListingPage
							dataRecipes={latestRecipes.salted}
							isLandingPage
						/>
					</div>
				</section>

				{/* CHILDREN SECTION */}
				<section className={classes.ChildrenSection}>
					<h2>За децата</h2>
					<p className={classes.ChildrenSectionSubtitle}>Забавления за по-малките, докато родителите се наслаждават на готвенето</p>

					<RecipesListingPage
						dataRecipes={childrenRecipes}
						isLandingPage
					/>
				</section>
			</Aux>
		);
	}
}

export default LandingPage;
